class InstagramVideoGrid extends HTMLElement {
  connectedCallback() {
    this.videos = Array.from(this.querySelectorAll('video'));
    this.cards = Array.from(this.querySelectorAll('.instagram-video-card'));

    this.videos.forEach((video) => {
      video.muted = true;
      video.playsInline = true;
    });

    this.setupAutoplay();
    this.setupHover();
  }

  setupAutoplay() {
    if (!this.videos.length) return;

    if (!('IntersectionObserver' in window)) {
      this.videos.forEach((video) => video.play().catch(() => {}));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

    this.videos.forEach((video) => this.observer.observe(video));
  }

  setupHover() {
    this.cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        this.classList.add('is-hovering');
        card.classList.add('is-active');
      });
      card.addEventListener('mouseleave', () => {
        this.classList.remove('is-hovering');
        card.classList.remove('is-active');
      });
      card.addEventListener('focusin', () => {
        this.classList.add('is-hovering');
        card.classList.add('is-active');
      });
      card.addEventListener('focusout', () => {
        this.classList.remove('is-hovering');
        card.classList.remove('is-active');
      });
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('instagram-video-grid', InstagramVideoGrid);
